// «الخدمات والأسعار» — a row of the المواعيد module menu (HANDOFF-erp-web §3
// row 4: «reuse the business app screens on the web», business app §5.10).
// Manager+ (business handoff §9: the hub's scheduling group is manager+; the
// BFF refuses a staff PATCH with 403). Module flag erp.core. Both operating
// modes: localbook serves GET/PATCH /v1/business/services with the BFF's shape.
//
// Integrator: spread `servicesRoutes` into the booking module's `routes`,
// `servicesMenu` into its `menu`, and `./mock/handlers` `handlers` into
// src/features/booking/mock/handlers.ts (the mock glob is one level deep).

import type { RouteObject } from 'react-router-dom';
import { gate, type Gate, type MenuItem } from '@/app/module-types';

export const SERVICES_PATH = '/services';

const servicesGate: Gate = { flag: 'erp.core', minRole: 'manager' };

export const servicesRoutes: RouteObject[] = [
  {
    path: SERVICES_PATH,
    lazy: () => import('./screens/Services').then((m) => ({ Component: m.ServicesRoute })),
    handle: gate(servicesGate),
  },
];

export const servicesMenu: MenuItem[] = [{ key: 'services', label: 'الخدمات والأسعار', to: SERVICES_PATH, ...servicesGate }];
